import { useMemo } from "react";
export var useDotVariant = function(param) {
    var distanceFromActive = param.distanceFromActive, numberOfDots = param.numberOfDots, index = param.index, slideIndex = param.slideIndex;
    return useMemo(function() {
        if (distanceFromActive === 0) {
            return 'active';
        }
        if (numberOfDots <= 5) {
            return 'secondary';
        }
        var lastIndex = numberOfDots - 1;
        if ((slideIndex < 3 && index === 4) || slideIndex > lastIndex - 3 && index === lastIndex - 4) {
            return 'furthermore';
        }
        if ((slideIndex < 3 && index === 3) || slideIndex > lastIndex - 3 && index === lastIndex - 3 || (slideIndex >= 3 && slideIndex <= lastIndex - 3 && Math.abs(distanceFromActive) === 2)) {
            return 'more';
        }
        if (Math.abs(distanceFromActive) > 2) {
            return 'hidden';
        }
        return 'secondary';
    }, [
        distanceFromActive,
        numberOfDots,
        index,
        slideIndex
    ]);
};
